import { render, staticRenderFns } from "./OldNewSysSel_CustImg.vue?vue&type=template&id=47e88918&"
import script from "./OldNewSysSel_CustImg.vue?vue&type=script&lang=js&"
export * from "./OldNewSysSel_CustImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports